export default __webpack_public_path__ + "static/media/Long Dark.635a3942.png";